/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconTextPlus = createReactComponent("text-plus", "IconTextPlus", [
  ["path", { d: "M19 10h-14", key: "svg-0" }],
  ["path", { d: "M5 6h14", key: "svg-1" }],
  ["path", { d: "M14 14h-9", key: "svg-2" }],
  ["path", { d: "M5 18h6", key: "svg-3" }],
  ["path", { d: "M18 15v6", key: "svg-4" }],
  ["path", { d: "M15 18h6", key: "svg-5" }]
]);

export { IconTextPlus as default };
//# sourceMappingURL=IconTextPlus.js.map
